import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fe8a5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home"
}
const _hoisted_2 = { class: "homeTopContent" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "cardInfo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupTitle" }, "当前卡未实名认证", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupContent" }, "根据工信部《入网用户真实身份信息登记规定》，您当前使用的流量卡或设备", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupTimer" }, "实名认证开放时间: 每日07:30-22:00", -1))
const _hoisted_10 = {
  key: 0,
  class: "popupAlert"
}
const _hoisted_11 = { class: "popupBtn" }

import { 
    getWifiCustomizationCardQueryCardMsg,
    getWifiCustomizationCardQueryCardRealNameStatus,
  } from '@/api'
  import { onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { showToast } from 'vant';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'cardData',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const status = ref(false)
  const realNamestatus = ref(false)
  const cardRealNameStatus = ref(false)
  let cardData = ref<any>()

  function goRealName () {
    router.push({ name: 'realName', params: {
      iccid: route.params.iccid
    }})
  }

  function getNamestatus() {
    // realNamestatus.value = false
    getWifiCustomizationCardQueryCardRealNameStatus({ iccid: route.params.iccid })
      .then((res: any) => {
        if (res.result) {
          _getWifiCustomizationCardQueryCardMsg()
          realNamestatus.value = false
        } else {
          showToast('您还未认证');
        }
      })
  }

  function goPayPackage() {
    router.push({ path: '/purchasePackage', query: {
      iccid: route.params.iccid,
      phone: cardData.value.phone,
      cardStatus: cardData.value.cardStatus
    }})
  }

  function _getWifiCustomizationCardQueryCardMsg() {
    getWifiCustomizationCardQueryCardMsg({ iccid: route.params.iccid })
      .then((res: any) => {
        console.log(res)
        if (res.code === 200) {
          cardData.value = res.result
        }
      })
  }

  function goPay () {
    goPayPackage()
  }

  onMounted(() => {
    _getWifiCustomizationCardQueryCardMsg()
  })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_unref(cardData))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, "ICCID：" + _toDisplayString(_unref(route).params.iccid? _unref(route).params.iccid: '- -'), 1),
          _createElementVNode("li", _hoisted_4, "卡号：" + _toDisplayString(_unref(cardData).phone? _unref(cardData).phone: '- -'), 1),
          _createElementVNode("li", _hoisted_5, "卡状态：" + _toDisplayString(_unref(cardData).cardStatus? _unref(cardData).cardStatus: '- -'), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_button, {
            type: "primary",
            color: "#FF7744",
            class: "goPayBtn",
            onClick: goPay
          }, {
            default: _withCtx(() => [
              _createTextVNode("充值")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_van_popup, {
          show: realNamestatus.value,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((realNamestatus).value = $event)),
          round: "",
          "close-on-popstate": true,
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            (cardRealNameStatus.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "如已实名，可能会存在同步延时，请稍后再查看，现可点击继续购买进入套餐充值页面"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (cardRealNameStatus.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "btn",
                    style: {"border-right":"1px solid #F7F7F7"},
                    onClick: goPayPackage
                  }, "继续购买"))
                : _createCommentVNode("", true),
              (!cardRealNameStatus.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "btn",
                    style: {"border-right":"1px solid #F7F7F7"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (realNamestatus.value = false))
                  }, "取消"))
                : _createCommentVNode("", true),
              (!cardRealNameStatus.value)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    class: "btn",
                    style: {"border-right":"1px solid #F7F7F7"},
                    onClick: getNamestatus
                  }, "我已认证"))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: "btn rightBtn",
                onClick: goRealName
              }, "立即认证")
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}
}

})